import React, { useContext, useEffect, useRef, useState } from "react";
import {
  View,
  BackHandler,
  TouchableOpacity,
  ActivityIndicator,
  Dimensions,
} from "react-native";
import WebView from "react-native-webview";
import { Separator, context } from "./accessories";
import CustomText from "./CustomText";
import Icon from "react-native-vector-icons/FontAwesome";
import Icon5 from "react-native-vector-icons/FontAwesome5";
import { android, ios, web } from "./Platform";
import { REDIRECT_URL } from "@env";
import { log } from "./CommonFunctions";
import { PDFViewer, shareContent } from "./RNComponents";
import ArrowSpinner from "./ArrowSpinner";

const ExternalSourceViewer = (props) => {
  const {
      route,
      children,
      onBack,
      isDisable = false,
      isSmallScreen = false,
      onLoad = () => {},
      style = {},
      setHideFooterButtons,
      handleNavigation,
      handleGetBankEmpDetails = () => {},
      setHideProgress,
      fromEsign,
      setPdfView = () => {},
      setShowEsignMenu = () => {},
      setWebviewRef = () => {},
      setiFrameviewRef = () => {},
      wStyle = {},
    } = props,
    { contextDetails, setContextDetails } = useContext(context), //Get value from context
    { navigation = props.navigation, SessionId = "" } = contextDetails,
    { params = {} } = route || {},
    { backTo } = params,
    isNeedBack = params.isNeedBack || props.isNeedBack;

  const webViewRef = useRef(null);
  const iframeRef = useRef(null);
  const [processingStatus, setProcessingStatus] = useState(null);

  let url = params.url || props.url || "";

  if (!web || window.location.host === "localhost:19006") {
    url = url.replace("../../../", REDIRECT_URL);
  }
  let isMobileWeb = Dimensions.get("window").width <= 480;

  const handleBackAction = () => {
    try {
      props?.route?.params?.onBack();
    } catch (error) {
      log("Error form handleBackAction", error);
    }
    try {
      onBack ? onBack() : backTo && navigation.goBack();
      // navigation.navigate(backTo, {
      //   GoToNav: GoToNav || 0,
      // });
    } catch (error) {
      log("Error form handleBackAction - onBack", error);
    }
    // return true;
  };

  useEffect(() => {
    if (fromEsign && (!web || isMobileWeb)) {
      // setHideProgress(true);
      setHideFooterButtons(false);
      setShowEsignMenu(false);
    }
    const backHandler = BackHandler.addEventListener(
      "hardwareBackPress",
      handleBackAction
    );
    return () => backHandler.remove();
  }, []);

  useEffect(() => {
    if (webViewRef == null) return;
    setWebviewRef(webViewRef);
  }, [webViewRef]);

  useEffect(() => {
    if (iframeRef == null) return;
    setiFrameviewRef(iframeRef);
  }, [iframeRef]);

  const handleNavigationStateChange = (navState) => {
    //setCurrentUrl(navState.url);
    //setPdfView
    if (
      navState.url?.toString().toLowerCase().includes(".pdf") &&
      (!web || isMobileWeb)
    ) {
      setPdfView(true);
    } else {
      setPdfView(false);
    }
  };

  return (
    <>
      <View
        style={{ flex: 1, flexDirection: "column", zIndex: 11111, ...wStyle }}
        pointerEvents={isDisable ? "none" : "auto"}
      >
        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
          {isNeedBack && (
            <TouchableOpacity activeOpacity={1} onPress={handleBackAction}>
              <CustomText
                bold={true}
                style={{ paddingVertical: 10, paddingHorizontal: 10 }}
              >
                <Icon name="angle-left" size={16} /> Back
              </CustomText>
            </TouchableOpacity>
          )}
          {url?.toString().toLowerCase().includes(".pdf") && !__DEV__ && (
            <>
              {"shareFileInit" === processingStatus ? (
                <View
                  style={{
                    paddingVertical: 10,
                    paddingHorizontal: 13,
                  }}
                >
                  <ArrowSpinner
                    isSpinner={true}
                    size={18}
                    color="#295b9a"
                    style={{
                      top: 2,
                    }}
                    duration={1200}
                  />
                </View>
              ) : (
                <TouchableOpacity
                  onPress={async () => {
                    if (processingStatus !== "shareFileInit") {
                      setProcessingStatus("shareFileInit");
                      shareContent(url, (status) => {
                        if (status === "success") {
                          setProcessingStatus("shareFileComplete");
                          setTimeout(() => {
                            setProcessingStatus(null);
                          }, 1500);
                        } else {
                          setProcessingStatus(null);
                        }
                      });
                    }
                  }}
                >
                  <CustomText
                    bold={true}
                    style={{
                      paddingVertical: 10,
                      paddingHorizontal: 12,
                    }}
                  >
                    {processingStatus === "shareFileComplete" ? (
                      <Icon size={18} name="check" color="green" />
                    ) : (
                      <Icon5
                        name={ios ? "share-square" : "share-alt"}
                        size={16}
                        color="#295b9a"
                      />
                    )}
                  </CustomText>
                </TouchableOpacity>
              )}
            </>
          )}
        </View>
        <>
          {children ? (
            <>{children}</>
          ) : !web && url ? (
            <>
              {url?.toString().toLowerCase().includes(".pdf") && !__DEV__ ? (
                <>
                  <View
                    style={{
                      flex: 1,
                      justifyContent: "flex-start",
                      alignItems: "center",
                      alignContent: "center",
                      alignSelf: "center",
                    }}
                  >
                    <PDFViewer url={url} />

                    <Separator />
                    <Separator />
                  </View>
                </>
              ) : (
                <WebView
                  ref={webViewRef}
                  onMessage={(event) => {
                    // These messages are sent from esign page
                    const message = event.nativeEvent.data;
                    if (message === "truvCompleted") {
                      setTimeout(() => {
                        handleGetBankEmpDetails();
                      }, 1500);
                    } else if (message.includes("GoBack")) {
                      handleNavigation(-1);
                    }

                    if (message === "hideFooterButtons") {
                      // Perform actions to hide footer buttons in your React Native app
                      //alert("here");
                      setHideFooterButtons(true);
                    }

                    if (message === "showFooterButtons") {
                      setHideFooterButtons(false);
                    }
                    if (message === "GoBack") {
                      handleNavigation(-1);
                    }
                    if (message === "GoNext") {
                      handleNavigation(1);
                    }
                    if (message === "hideProgressBar") {
                      setHideProgress(true);
                    }
                    if (message === "showProgressBar") {
                      setHideProgress(false);
                    }
                    if (message === "ShowEsignMenu") {
                      setShowEsignMenu(true);
                    }

                    if (message === "hideEsignMenu") {
                      setShowEsignMenu(false);
                    }
                  }}
                  onError={(syntheticEvent) => {
                    const { nativeEvent } = syntheticEvent;
                  }}
                  onLoad={(syntheticEvent) => {
                    const { nativeEvent } = syntheticEvent;
                    onLoad();
                    if (
                      webViewRef.current &&
                      !nativeEvent["title"] &&
                      android
                    ) {
                      webViewRef.current.reload();
                    }
                  }}
                  javaScriptEnabled={true}
                  originWhitelist={["*"]}
                  domStorageEnabled={true}
                  source={{
                    uri: ios
                      ? url
                      : url.indexOf(".pdf") > -1
                      ? `http://docs.google.com/gview?embedded=true&url=${url}`
                      : url,
                  }}
                  onNavigationStateChange={handleNavigationStateChange}
                  style={{
                    flex: 1,
                    // borderWidth: 1,
                    borderColor: "#888",
                    marginHorizontal: 5,
                  }}
                />
              )}
            </>
          ) : (
            <>
              <iframe
                ref={iframeRef}
                className="externalFrame"
                src={url}
                style={{
                  ...{
                    border: "none",
                    flex: 1,
                    width: "100%",
                  },
                  ...style,
                }}
                onLoad={onLoad}
              />
            </>
          )}
        </>
      </View>
    </>
  );
};

export default ExternalSourceViewer;
